import { postStore } from '@/utils/http/http'
import { LIVE_GW_URL } from '@/utils/http/baseUrl'
import StoreController from '../view/store/store.controller'

/**
 * @method POST-门店系统-订单业绩-聚合
 */
export const getOrderPerformanceSumByStore = params => {
  return postStore(
    `${LIVE_GW_URL}/health/v1/h5/store/report/getOrderPerformanceSumByStore`,
    params,
    false,
    StoreController.apiHeaderConfig()
  )
}
